import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { DocumentConfigOutBatcher } from '../models/document-config-out-batcher';

import { DataFieldGroupContainerComponent } from '../../shared/datafields/datafield-group-container.component';

@Component({
    selector: 'app-developer-document-configs-batching-type',
    templateUrl: './developer-document-configs-batching-type.component.html',
    styleUrls: ['./developer-document-configs-batching-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, DataFieldGroupContainerComponent]
})
export class DeveloperDocumentConfigBatchingTypeComponent {

    @Input() documentConfigOutBatcher: DocumentConfigOutBatcher;
    formGroup: UntypedFormGroup = new UntypedFormGroup({});

    showConfiguration: boolean = false;
    isFormValid: boolean = false;

    constructor() {
        this.isFormValid = this.formGroup.valid;
        this.formGroup.statusChanges
        .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
        .subscribe(
            result => this.isFormValid = (result === 'VALID')
        );
    }
}
